import Dbm from "dbm";
import Website from "../../index.js";

//import * as PIXI from "pixi.js";
//import Matter from "matter-js";

export default class LoadingGame extends Dbm.core.BaseObject {
    _construct() {
        super._construct();

        this.item.requireProperty("game", null);

        let layer = new PIXI.Container()
        this.item.requireProperty("pixiLayer", layer);

        let background = Dbm.flow.externalObject(new PIXI.Container());
        background.addProperty("alpha", 0);

        layer.addChild(background.object);
        this.item.setValue("background", background.item);

        let logo = Dbm.flow.externalObject(new PIXI.Container());
        logo.addProperty("alpha", 0);

        layer.addChild(logo.object);
        this.item.setValue("logo", logo.item);

        let progressBar = new Website.game.graphics.ProgressBar();
        layer.addChild(progressBar.item.pixiLayer);
        this.item.setValue("progressBar", progressBar.item);

        progressBar.item.pixiLayer.x = Website.game.Sizes.CENTER_X-0.5*100;
        progressBar.item.pixiLayer.y = 140;

        this.item.requireProperty("state", "select").addUpdate(this._getScopedCallFunctionCommand(this._stateChanged));
    }

    prepare() {
        //console.log("prepare");

        let startLoaded = Dbm.flow.updatefunctions.logic.allAtValue(Dbm.loading.LoadingStatus.LOADED);
        startLoaded.addCheck(Website.game.getAsset("screens/start").properties.status);
        startLoaded.addCheck(Website.game.getAsset("screens/background").properties.status);
        Dbm.flow.runWhenMatched(startLoaded.output.properties.value, true, Dbm.commands.callFunction(this._startLoaded.bind(this)));

        let allLoaded = Dbm.flow.updatefunctions.logic.allAtValue(Dbm.loading.LoadingStatus.LOADED);

        this.loaders = [
            Website.game.getAsset("screens/start"),
            Website.game.getAsset("screens/select-character"),
            Website.game.getAsset("sounds/music"),
            Website.game.getAsset("sounds/interface"),
            Website.game.getAsset("sounds/game"),
            Website.game.getAsset("screens/gameover"),
            Website.game.getAsset("screens/gameover/papers"),
            Website.game.getAsset("screens/gameover/poster"),
            Website.game.getAsset("screens/level-completed"),
            Website.game.getAsset("screens/background"),
            Website.game.getAsset("screens/button"),
            Website.game.getAsset("screens/button-orange"),
            Website.game.getAsset("screens/frame"),
            Website.game.getAsset("screens/reflection-mask"),
            Website.game.getAsset("screens/computer-window"),
            Website.game.getAsset("screens/level-line"),
            Website.game.getAsset("screens/level-preview-bubble"),
            Website.game.getAsset("screens/level-preview"),
            Website.game.getAsset("screens/map"),
            Website.game.getAsset("enemies/boss"),
            Website.game.getAsset("game-buttons"),
            Website.game.getAsset("objects/sign"),
        ];

        let currentArray = this.loaders;
        let currentArrayLength = currentArray.length;
        for(let i = 0; i < currentArrayLength; i++) {
            allLoaded.addCheck(currentArray[i].properties.status);
        }
        
        Dbm.flow.runWhenMatched(allLoaded.output.properties.value, true, Dbm.commands.callFunction(this._loaded.bind(this)));
    }

    start() {
        this.item.progressBar.animationLayer.properties.alpha.animateValue(1, 0.5);
    }

    _startLoaded() {
        //console.log("_startLoaded");

        let texture = Website.game.getTextures("screens/start", "logo")[0];
        
        let logoWidthOfScreen = 0.8;
        let scale = logoWidthOfScreen*Website.game.Sizes.WIDTH/texture.width;

        let margin = 0.5*(Website.game.Sizes.WIDTH-(scale*texture.width));
        let logoHeight = (scale*texture.height);

        let sprite = new PIXI.Sprite(texture);
        sprite.scale = scale;
        sprite.position.x = margin;
        sprite.position.y = margin;
        this.item.logo.object.addChild(sprite);

        let backgroundSprite = Website.game.getSprite("screens/background", "main");
        backgroundSprite.anchor.set(0, 0);
        this.item.background.object.addChild(backgroundSprite);

        this.item.logo.alpha = 0;
        this.item.logo.properties.alpha.animateValue(1, 1.2);

        this.item.background.alpha = 0;
        this.item.background.properties.alpha.animateValue(1, 2);
    }

    _loaded() {
        //console.log("_loaded");

        this.item.progressBar.animationLayer.properties.scale.animateValue(1.2, 0.3);
        this.item.progressBar.animationLayer.properties.scale.addAddionalAnimation(1.2, 0.5, 0.3, 0.3);
        this.item.progressBar.animationLayer.properties.alpha.animateValue(0, 0.2, 0.4);
        
        this.item.properties.state.delayValue("outroDone", 1.2);
    }

    _stateChanged() {
        if(this.item.state === "outroDone") {
            this.item.game.controller.changeScreen("start");
        }
    }

    update(aTime, aDelta) {

        let loadedLoaders = 0;

        let currentArray = this.loaders;
        let currentArrayLength = currentArray.length;
        for(let i = 0; i < currentArrayLength; i++) {
            if(currentArray[i].status === Dbm.loading.LoadingStatus.LOADED) {
                loadedLoaders++;
            }
        }

        let percentage = loadedLoaders/(currentArrayLength);

        this.item.progressBar.percentage = percentage;
        this.item.progressBar.controller.update(aTime, aDelta);
    }

    stop() {
        
    }
}